import React from "react";
import { Field } from "formik";
import PropTypes from "prop-types";
import { InputLabel } from "@material-ui/core";
import useStyles from "../../../assets/jss/material-dashboard-react/components/customDatepickerStyle";

// import TextError from "./TextError";

function Radio(props) {
  const classes = useStyles();
  const { label, name, options, required, handleClick, ...rest } = props;
  return (
    <div className="form-control">
      <Field name={name} {...rest}>
        {({ field, meta }) => {
          return options.map((option) => {
            return (
              <React.Fragment key={option.key}>
                <br />
                <InputLabel htmlFor={name} className={classes.label}>
                  {meta.error && meta.touched ? meta.error : label}
                  {required ? <span style={{ color: "red" }}> *</span> : null}
                </InputLabel>
                <input
                  type="radio"
                  id={option.value}
                  {...field}
                  value={option.value}
                  checked={field.value === option.value}
                  onClick={handleClick}
                />
                <label htmlFor={option.value}>{option.key}</label>
              </React.Fragment>
            );
          });
        }}
      </Field>
      {/* <ErrorMessage name={name} component={TextError} /> */}
    </div>
  );
}

Radio.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  handleClick: PropTypes.func,
  required: PropTypes.bool,
};

export default Radio;
